import React from 'react';
import { HiOutlineShieldCheck } from 'react-icons/hi';
import { FiCalendar } from 'react-icons/fi';
import useInspectorAccess from '../hooks/useInspectorAccess';

export default function InspectorAccessWidget() {
  const handleGrantAccess = useInspectorAccess();

  return (
    <div className="w-full max-w-md space-y-4 font-sans select-none">

      {/* 1. Main Inspector Access Control Card */}
      <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm">

        <div className="text-left space-y-2 mb-5">
          <h3 className="text-slate-900 font-extrabold text-base tracking-tight">
            Inspector Access
          </h3>

          <p className="text-xs font-medium text-slate-500 leading-relaxed">
            Give health inspectors secure, time-limited access to view compliance records.
          </p>
        </div>

        {/* Grant Access — token retrieved from localStorage and appended as ?token= param */}
        <button
          type="button"
          onClick={handleGrantAccess}
          className="w-full flex items-center justify-center space-x-2 py-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-xs font-bold rounded-xl shadow-lg shadow-blue-200 transition duration-150 ease-in-out"
        >
          <HiOutlineShieldCheck className="w-4 h-4" />
          <span>Grant Inspector Access</span>
        </button>

        <p className="text-[11px] font-medium text-slate-400 mt-4 text-center">
          You control the duration and data they can see.
        </p>
      </div>

      {/* 2. Next Internal Audit Due Reminder Bar */}
      <div className="bg-amber-50/60 border border-amber-100/70 rounded-2xl p-4 flex items-center space-x-4">

        <div className="w-10 h-10 bg-amber-100/50 rounded-xl flex items-center justify-center text-amber-700 flex-shrink-0 shadow-sm">
          <FiCalendar className="w-5 h-5 stroke-[2.5]" />
        </div>

        <div className="text-left space-y-0.5">
          <span className="block text-xs font-black text-amber-800 tracking-tight">
            Next Internal Audit Due
          </span>

          <div className="flex items-baseline space-x-1.5 flex-wrap">
            <span className="text-sm font-extrabold text-slate-900">
              Not tracked
            </span>

            <span className="text-[11px] font-medium text-slate-400">
              Audit schedule not recorded
            </span>
          </div>
        </div>
      </div>

    </div>
  );
}
